import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { "clip-path": "url(#a)" }, [
      createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "m11.85 19.975-6.4-6.4 10.8-10.8c1.8-1.8 4.6-1.8 6.4 0s1.8 4.6 0 6.4zm-4.9 2.6h-7l6-6.5 3.5 3.5zm8 1h9v-2h-9z",
        "clip-rule": "evenodd"
      })
    ], -1),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "a" }, [
        createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]));
}
const EditorHighlight = { render };
export {
  EditorHighlight as default,
  render
};
//# sourceMappingURL=EditorHighlight.svg.js.map
